@if (isVisible) {
  <div class="loading-overlay">
    <mat-spinner [diameter]="50" class="loading-spinner"></mat-spinner>
  </div>
}
